import * as scene from '../scene.js';
import * as loader from '../loader.js';
import * as audio from '../audio.js';
import * as triangle from '../triangle.js';

export {
    init,
}

let melopee;

const pluieGain = 12;
const POIs = [
    {
        name: 'pluie',
        position: { x: -23, y: 8, z: 0 },
        color: 'hsl(225, 100%, 50%)',
        sound: {
            name: 'pluie',
            gain: pluieGain,
        },
        collision: {
            radius: 2,
        },
        async onEnter() {
            this.sound.source.fadeTo(2, -90, pluieGain);
            this.collision.radius = 4;
            
            melopee = await audio.buffers.play('melopee', {
                destination: this.sound.panner,
                gain: 0,
                when: 2,
            });

            triangle.drop('stonehenge-triangle-7', this.position, {
                collisionRadius: 0.5,
                delay: 8,
            });
        },
        onLeave() {
            this.sound.source.fadeTo(2, pluieGain, -90);
            this.collision.radius = 2;
            melopee?.fade(2, -90, true);
        },
        onStart() {
            audio.panner.play(this);
        },
    },
];

const sounds = [
    { name: 'pluie', url: new URL('../../sound/PluieLegere_canopee.wav', import.meta.url) },
    { name: 'melopee', url: new URL('../../sound/Melopee_sirene.wav', import.meta.url) },
];

const images = [
];

function init() {
    scene.addPOIs(POIs);
    //loader.addImages(images);
    loader.addSounds(sounds);
};
